module.exports = __webpack_public_path__ + "static/grouped-bar-89fcc5d280f9aa540d564fbae1d6e6a5.png";